import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActionConfigDTO, EntityGroupHeaderDTO, MenuDTO } from '../../../../../system/system-dtos';

@Component({
  selector: 'app-entity-group-actions',
  templateUrl: './entity-group-actions.component.html',
  styleUrls: ['./entity-group-actions.component.scss'],
  standalone: false,
})
export class EntityGroupActionsComponent implements OnChanges {
  @Input() headerConfig: EntityGroupHeaderDTO;

  @Input() menuConfig: MenuDTO;

  @Input() baseUrl: string;

  @Input() headerData: any;

  isOpen: boolean = false;

  actionGroups: ActionGroup[];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const actionGroups: ActionGroup[] = [];
    const otherActions: ActionConfigDTO[] = [];
    (this.headerConfig?.actions || []).forEach((a) => {
      if (!a.children || a.children.length === 0) {
        otherActions.push(a);
      } else {
        actionGroups.push({ name: a.parentMenuLabel, items: a.children });
      }
    });
    if (otherActions.length > 0) {
      actionGroups.push({ name: 'Other', items: otherActions });
    }
    this.actionGroups = actionGroups;
  }
}

export interface ActionGroup {
  name: string;
  items: ActionConfigDTO[];
}
